import './index.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import store, { persistor } from '../src/app/store'
import { StoreContextProvider } from './hooks/context/StoreContext';
import React from 'react';
import ReactDOM from 'react-dom/client';
import rotasAdmin from './routes/admin/rotasAdmin';
import rotasModulo from './routes/modulos/rotasModulo';
import rotasBalcao from './routes/balcao/rotasBalcao';
import rotaLogin from './routes/login/rotaLogin';
import Animations from './components/animation/Animation';
import rotasCaixa from './routes/caixa/rotasCaixa';

const combinarRotas = [
  ...rotaLogin.routes,
  ...rotasModulo.routes,
  ...rotasBalcao.routes,
  ...rotasAdmin.routes,
  ...rotasCaixa.routes,
];

const router = createBrowserRouter(combinarRotas);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<Animations />} persistor={persistor}>
        <StoreContextProvider>
          <RouterProvider router={router} />
        </StoreContextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
